export default {
  adUnitGroup: {
    viewTitle: {
      adUnitGroup: "Adunit Group",
      newAdUnitGroup: "New Adunit Group",
      editAdUnitGroup: "Edit Adunit Group",
    },
    tabTitle: {
      adUnitGroup: "AdunitGroup_一覧",
      newAdUnitGroup: "AdunitGroup_作成",
      editAdUnitGroup: "AdunitGroup_編集",
    },
    tableHeader: {
      name: "グループ名",
      publisher: "パブリッシャー名",
    },
    button: {
      create: "NEW GROUP",
      edit: "編集",
      delete: "削除",
    },
    notify: {
      success: {
        save: "AdunitGroupの保存に成功しました",
        delete: "AdunitGroupの削除に成功しました",
      },
      error: {
        failedSave: "AdunitGroupの保存に失敗しました",
        delete: "AdunitGroupの削除に失敗しました",
        emptyAdUnitGroup: "Adunitを選択してください",
      },
    },
    text: {
      editGeneral: {
        title: "全般設定",
        adUnitGroupName: "グループ名",
        publisher: "パブリッシャー",
      },
      adUnitSelector: {
        title: "広告枠",
        selectAdUnitGroup: "広告枠を選択",
        selectedAdUnitGroup: "選択済み広告枠",
        search: "広告枠名で検索",
        noFilterValue: "対象の項目がありません",
      },
      action: {
        title: "アクション",
      },
      changePublisherDialog: {
        title:
          "パブリッシャーを変更すると選択された広告枠はすべてリセットされます。よろしいですか？",
      },
      saveDialog: {
        title: "下記の内容で保存します",
        text: {
          adUnitGroupName: "グループ名",
          adUnitListSize: "所属広告枠: {listSize}件",
        },
      },
      deleteDialog: {
        title: "確認",
        text: "AdunitGroupを削除します",
      },
      searchAdUnitGroup: "広告枠グループを検索",
      unAuthorizedDialog: {
        text: "許可されていない項目です。AdunitGroup一覧へ移動します",
      },
    },
  },
};
